/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Live_Caption_Chars_RemainingInputs */

const en_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} characters remaining`)
};

const fr_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caractères restants`)
};

const de_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} verbleibende Zeichen`)
};

const it_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caratteri rimanenti`)
};

const ru_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} символов осталось`)
};

const es_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caracteres restantes`)
};

const zh_cn2_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩余${i?.count}个字符`)
};

const ja_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残り文字数 ${i?.count}`)
};

const hi_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शेष वर्ण ${i?.count}`)
};

const pt_pt2_live_caption_chars_remaining = /** @type {(inputs: Live_Caption_Chars_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caracteres restantes`)
};

/**
* | output |
* | --- |
* | "{count} characters remaining" |
*
* @param {Live_Caption_Chars_RemainingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_chars_remaining = /** @type {((inputs: Live_Caption_Chars_RemainingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Chars_RemainingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_chars_remaining(inputs)
	if (locale === "de") return de_live_caption_chars_remaining(inputs)
	if (locale === "it") return it_live_caption_chars_remaining(inputs)
	if (locale === "ru") return ru_live_caption_chars_remaining(inputs)
	if (locale === "es") return es_live_caption_chars_remaining(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_chars_remaining(inputs)
	if (locale === "ja") return ja_live_caption_chars_remaining(inputs)
	if (locale === "hi") return hi_live_caption_chars_remaining(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_chars_remaining(inputs)
	return en_live_caption_chars_remaining(inputs)
});